import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import UserProfileIcon from './ProfileIcon/UserProfileIcon';
const AutocompleteWrapper = styled.div `
  flex-grow: 1;
  width: 100%;
  height: auto;
  max-height: 156px;
  position: absolute;
  z-index: 60;
  margin-bottom: 4px;
  background-color: #1d1d21;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  left: 0px;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 12px;
  padding-right: 12px;
  color: #fff;
  overflow-y: scroll;

  .listItem {
    display: flex;
    align-items: center;
    padding: 3px;
    cursor: pointer;
    border-radius: 8px;
    width: 100%;
  }
  .accountIdText {
    color: #686672;
    font-family: Helvetica Neue;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  .accountInfo {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    font-family: Helvetica Neue;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }
  .profileIcon {
    height: 24px;
    width: 24px;
    border-radius: 100%;
    background-color: red;
  }
`;
export const POPUP_POSITION_SWITCH_HEIGHT = 300;
function AutocompleteList({ onSelect, autocompleteAccounts, getIconFromCache, }) {
    const onResultClick = (id) => {
        onSelect(id);
    };
    const [elementHoverTop, setElementHoverTop] = useState(true);
    useEffect(() => {
        const element = document.getElementById('wrapper');
        if (element) {
            const elementPosition = element.getBoundingClientRect();
            if (elementPosition.top < POPUP_POSITION_SWITCH_HEIGHT) {
                setElementHoverTop(false);
            }
            else {
                setElementHoverTop(true);
            }
        }
    }, []);
    return (_jsx(AutocompleteWrapper, Object.assign({ id: "wrapper", style: elementHoverTop ? { bottom: '100%' } : { top: '100%' } }, { children: autocompleteAccounts.map((account, id) => (_jsx("div", Object.assign({ className: "listItem", onClick: () => onResultClick(account.id) }, { children: _jsxs("div", Object.assign({ className: "accountInfo" }, { children: [_jsx(UserProfileIcon, { accountId: account.id, getIconFromCache: getIconFromCache, showStatus: false, width: '32px', height: '32px', active: account.active }), _jsx("span", { children: account.id })] })) }), id))) })));
}
export default AutocompleteList;
